import VideoElement from './VideoElement';
import VideoElementDefinition from './VideoElementDefinition';
import VideoElementMetaData from './VideoElementMetaData';

export default {
  VideoElement: VideoElement,
  VideoElementDefinition: VideoElementDefinition,
  VideoElementType: VideoElementMetaData.type
};
